import * as React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Page, PageContent, PageHeader } from '../components/common/index';
import { userIsNotAuthenticatedRedir } from './authComponents';

import authActions from '../auth/authActions';
import Button from '../components/buttons/Button';

interface Props {
	actions: any;
}
class RequireMultiFactorLoginPage extends React.Component<Props, {}> {

	render() {
		return (
			<div className="navbar-account">
				<Page>
					<PageContent>
						<PageHeader isCentered={true} className="page-header-sm" title="Log In Denied" />
						<div className="mt-4 text-center">
							<p className="mt-3">
								You tried to login to the customer portal using an administration account.
								<br />
								Please access the administration site via&nbsp;
								<Button 
									className="btn-link btn-link-inline"
									onClick={this.redirectToMultiFactorLogin}
								>
									{window.location.origin}/admin
								</Button>
								&nbsp;or click the button below.
							</p>
							<Button className="btn-primary" onClick={this.redirectToMultiFactorLogin}>Admin Log In</Button>
						</div>
					</PageContent>
				</Page>		
			</div>
		);
	}

	private redirectToMultiFactorLogin = () => {
		this.props.actions.loginAdmin();
	}
}

function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connector = connect(null, mapDispatchToProps)(RequireMultiFactorLoginPage);
export default userIsNotAuthenticatedRedir(connector as any);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/RequireMultiFactorLoginPage.tsx